// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active[data-v-f737b83c]{\r\n  color:#fff;\r\n  background-color: #007bff !important;\r\n  border-color: #007bff !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
